var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { composeRenderProps, Tag as AriaTag, TagGroup as AriaTagGroup, TagList, Text, } from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { tv } from "tailwind-variants";
import { Description, Label } from "./Field";
import { focusRing } from "./utils";
const colors = {
    gray: "bg-backgroundQuartenary text-contentTertiary border-borderTertiary rounded-md font-regular",
    positive: "bg-backgroundPositive text-contentPositive border-borderPositive",
    yellow: "bg-backgroundAccentYellow text-contentAccentYellow border-borderAccentYellow",
    info: "bg-backgroundInformation text-contentInformation border-borderInformation",
    warning: "bg-backgroundWarning text-contentWarning border-borderWarning",
    green: "bg-backgroundAccentGreen text-contentAccentGreen border-borderAccentGreen",
    alert: "bg-backgroundAlert text-contentAlert border-borderAlert",
    yellowLight: "bg-backgroundYellowLight text-contentPrimary border-borderYellow",
    transparent: "bg-transparent text-contentTertiary border-none",
};
const tagStyles = tv({
    extend: focusRing,
    base: "transition text-xs font-regular rounded-full px-3 py-[3px] flex items-center max-w-fit gap-1",
    variants: {
        color: colors,
        isSelected: {
            true: "bg-black text-white border-transparent forced-colors:bg-[Highlight] forced-color-adjust-none",
        },
        isDisabled: {
            true: "bg-gray-100 text-gray-300 forced-colors:text-[GrayText]",
        },
    },
    defaultVariants: {
        color: "green",
    },
});
export function Tag(_a) {
    var { children, color = "green" } = _a, props = __rest(_a, ["children", "color"]);
    let textValue = typeof children === "string" ? children : undefined;
    return (_jsx(AriaTag, Object.assign({ textValue: textValue }, props, { className: composeRenderProps(props.className, (className, renderProps) => tagStyles(Object.assign(Object.assign({}, renderProps), { className, color: color }))), children: children })));
}
export function TagGroup(_a) {
    var { label, description, errorMessage, items, children, renderEmptyState } = _a, props = __rest(_a, ["label", "description", "errorMessage", "items", "children", "renderEmptyState"]);
    return (_jsxs(AriaTagGroup, Object.assign({}, props, { className: twMerge("flex flex-col gap-1", props.className), children: [label && _jsx(Label, { children: label }), _jsx(TagList, { items: items, renderEmptyState: renderEmptyState, className: twMerge("flex flex-wrap gap-2", props.containerClassName), children: children }), description && _jsx(Description, { children: description }), errorMessage && (_jsx(Text, { slot: "errorMessage", className: "text-sm text-red-600", children: errorMessage }))] })));
}
